import { toast } from 'sonner';
import { copyToClipboard } from './global';

export function cleanFolioNumber(str) {
  try {
    str = str.toString();
  } catch (e) {
    return '';
  }
  return str.replace(/[^a-z0-9]/gi, '');
}

export function parseFolioParts(folioString) {
  if (!folioString || !String(folioString).trim()) return [];
  return String(folioString)
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);
}

export function formatFolioForCopy(folioString, { cleaned = false } = {}) {
  const parts = parseFolioParts(folioString);
  if (parts.length === 0) return '';
  if (cleaned) {
    return parts.map(cleanFolioNumber).filter(Boolean).join(', ');
  }
  return parts.join(', ');
}

export async function copyFolioToClipboard(folioString, { cleaned = false } = {}) {
  const textToCopy = cleaned
    ? formatFolioForCopy(folioString, { cleaned: true })
    : String(folioString ?? '').trim();

  if (!textToCopy) {
    toast.info('Nothing to copy');
    return false;
  }

  await copyToClipboard(textToCopy);
  toast.success(
    cleaned ? 'Clean folio number copied to clipboard!' : 'Folio number copied to clipboard!'
  );
  return true;
}
